import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HelpCircle, ChevronDown } from 'lucide-react';
const faqs = [{
  question: "It's too expensive",
  answer: 'A neglected lawn reduces your property value more than it costs to maintain it.'
}, {
  question: 'I already have someone',
  answer: 'Do they show up on time? Are they insured? Are they a registered business? Compare before you decide.'
}, {
  question: "I'll do it myself",
  answer: 'How much is your free time worth? We do it better and you get to rest.'
}, {
  question: "I don't know if the price is fair",
  answer: 'The quote is free and no obligation. Compare at your own pace.'
}, {
  question: "I've had bad experiences before",
  answer: "That's why we're a registered LLC. If something isn't right, we come back at no cost."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-16 md:py-24 bg-[#f9f7f2]" data-id="element-80">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-82">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 text-blue-600 mb-6" data-id="element-83">
            <HelpCircle className="w-8 h-8" data-id="element-84" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2E1B] mb-6" data-id="element-85">
            OBJECTIONS ANSWERED
          </h2>
          <div className="w-24 h-1 bg-blue-500 mx-auto rounded-full" data-id="element-86"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-87">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-88">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-89">
                <span className="font-bold text-lg text-[#1B2E1B]" data-id="element-90">
                  "{faq.question}"
                </span>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-91" />
              </button>

              <AnimatePresence data-id="element-92">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-93">
                    <div className="px-6 pb-5 text-gray-600 border-t border-gray-100 pt-4" data-id="element-94">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}